var map = {
	"./de-DE.json": [
		"./src/assets/cl-console-components/i18n/de-DE.json",
		3
	],
	"./en-GB.json": [
		"./src/assets/cl-console-components/i18n/en-GB.json",
		4
	],
	"./en-US.json": [
		"./src/assets/cl-console-components/i18n/en-US.json",
		5
	],
	"./fr-FR.json": [
		"./src/assets/cl-console-components/i18n/fr-FR.json",
		6
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}
	return __webpack_require__.e(ids[1]).then(function() {
		var id = ids[0];
		return __webpack_require__.t(id, 3);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./src/assets/cl-console-components/i18n lazy recursive ^\\.\\/.*\\.json$";
module.exports = webpackAsyncContext;